package com.karawek.core.ui.designcatalog.sections

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography
import com.karawek.core.ui.theme.CoreSpacing

@Composable
fun CatalogColors() {
    Column(verticalArrangement = Arrangement.spacedBy(CoreSpacing.md)) {
        Text("Colors", style = CoreTypography.title)

        ColorRow("Primary", CoreTheme.colors.primary)
        ColorRow("On Primary", CoreTheme.colors.onPrimary)
        ColorRow("Background", CoreTheme.colors.background)
        ColorRow("Surface", CoreTheme.colors.surface)
        ColorRow("Surface Variant", CoreTheme.colors.surfaceVariant)
        ColorRow("Text Primary", CoreTheme.colors.textPrimary)
        ColorRow("Text Secondary", CoreTheme.colors.textSecondary)
        ColorRow("Error", CoreTheme.colors.error)
    }
}

@Composable
private fun ColorRow(
    name: String,
    color: Color,
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(CoreSpacing.md),
    ) {
        Box(
            modifier = Modifier
                .size(40.dp)
                .background(color),
        )
        Text(name, style = CoreTypography.body)
    }
}
